import CollapsibleSection from 'components/CollapsibleSection';
import { useTranslation } from 'react-i18next';
import Submission from 'types/Submission';
import Metadata from 'components/Metadata';
import Nl2Br from 'components/Nl2Br';

interface Props {
  submission: Submission;
}

export default function SubmissionSidebarDataCapture(props: Props) {
  const { submission } = props;
  const { t } = useTranslation();
  if (!submission.dataCaptureResponses.length) return null;

  return (
    <CollapsibleSection
      title={t('ugcRequestShow.submissions.sidebar.dataCapture.heading')}
    >
      {submission.dataCaptureResponses.map((dcr) => {
        const { field, response } = dcr;
        if (!field) return null;

        return (
          <Metadata key={field} title={field} copyValue={response}>
            <Nl2Br text={response} />
          </Metadata>
        );
      })}
    </CollapsibleSection>
  );
}
